import React from 'react';

const LoadingGlobal = ({ overlay, overlayBlack }) => {
    return (
        <>
            <div className="overlay show" style={{ backgroundColor: overlay && 'rgba(0,0,0,0.5)' }} />
            <div className="spanner show">
                <div className="loader" style={{ color: overlay && '#fff' || overlayBlack && '#313A46' }} />
                <p style={{ color: overlay && '#fff' }}>Memuat data, harap tunggu.</p>
            </div>
        </>
    );
};

export default LoadingGlobal;
